import React, { useContext, useEffect, useState } from "react";
import BodyCircleChart from "./general/BodyCircleChart";
import { getBodiesCount } from "../api/scheduling";
import { CircularProgress } from "@mui/material";
import AuthContext from "../helpers/AuthContext";
import { useCompany } from "../helpers/CompanyContext";

const BVM_COMPANY_ID = 2;

export default function Home() {
  const [bodiesCount, setBodiesCount] = useState(null);
  const { logoutUser, user } = useContext(AuthContext);
  const { selectedCompany } = useCompany();

  const companyId = user?.role_id === 1 ? selectedCompany : user?.company_id;
  const isBVM = companyId === BVM_COMPANY_ID;

  useEffect(() => {
    getBodiesCount(companyId)
      .then((res) => {
        console.log("bodies count", res);
        if (!res) logoutUser();
        else setBodiesCount(res);
      })
      .catch((err) => {
        logoutUser();
        console.log("error in fetching the bodies count", err);
      });
  }, [selectedCompany, user, logoutUser]);

  if (!bodiesCount) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-5">
        <CircularProgress variant="determinate" value={50} valueBuffer={20} />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-around justify-content-center mt-1 px-4 py-0">
      <h4 className="mb-0 text-center text-acumen-color mt-2 pt-0">
        Plant Overview
      </h4>

      <h5 className="ms-3 mb-0 mt-0 pt-0">Today</h5>
      <div className="d-flex flex-wrap justify-content-around align-items-center mb-2 mt-0 py-0">
        <BodyCircleChart
          speciesName="Beef"
          chartData={bodiesCount.today.Bovine}
          color="#964B00"
          lightColor="#CBA280"
        />
        <BodyCircleChart
          speciesName="Lamb"
          chartData={bodiesCount.today.Ovine}
          color="green"
          lightColor="#80C080"
        />
        <BodyCircleChart
          speciesName="Pig"
          chartData={bodiesCount.today.Porcine}
          lightColor="pink"
          color="#B3868E"
        />
        {isBVM && (
          <>
            <BodyCircleChart
              speciesName="Goat"
              chartData={bodiesCount.today.Caprine}
              color="#8B6914"
              lightColor="#C4A35A"
            />
            <BodyCircleChart
              speciesName="Others"
              chartData={bodiesCount.today.Other}
              color="#4A7B9D"
              lightColor="#89B4CC"
            />
          </>
        )}
      </div>

      <h5 className="ms-3 mb-0">This Week</h5>
      <div className="d-flex flex-wrap justify-content-around align-items-center">
        <BodyCircleChart
          speciesName="Beef"
          chartData={bodiesCount.week.Bovine}
          color="#964B00"
          lightColor="#CBA280"
        />
        <BodyCircleChart
          speciesName="Lamb"
          chartData={bodiesCount.week.Ovine}
          color="green"
          lightColor="#80C080"
        />
        <BodyCircleChart
          speciesName="Pig"
          chartData={bodiesCount.week.Porcine}
          lightColor="pink"
          color="#B3868E"
        />
        {isBVM && (
          <>
            <BodyCircleChart
              speciesName="Goat"
              chartData={bodiesCount.week.Caprine}
              color="#8B6914"
              lightColor="#C4A35A"
            />
            <BodyCircleChart
              speciesName="Others"
              chartData={bodiesCount.week.Other}
              color="#4A7B9D"
              lightColor="#89B4CC"
            />
          </>
        )}
      </div>
    </div>
  );
}